<div style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%;">
  <button mat-raised-button color="primary" (click)="goToSignatureCreate()">Incepe procesul de semnare</button>
</div>
